if ($('.js-cinemaSlider').length > 0) {
	const cinemaSlider = new Swiper($('.js-cinemaSlider .swiper-container'), {
		speed: 1000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: '.js-cinemaSlider .swiper-next',
			prevEl: '.js-cinemaSlider .swiper-prev',
		},
		pagination: {
			el: '.js-cinemaSlider .swiper-pagination',
			clickable: true,
		},
	});
}
